import * as Yup from 'yup';
import { minOneWhenTrue } from '../utils';

const groupSchema = Yup.object({
    noOfIndividualParticipants: Yup.number().integer().min(1).required('error_required_field'),
    wasNatureOfSupportAndConfidentialityDiscussed: Yup.boolean().required('error_required_field'),
    howGroupPresented: Yup.string(),
    anyInterventionProvided: Yup.string().required('error_required_field'),
    anyAdditionalSupportProvided: Yup.string(),
});

export const initialValues = {
    wereThereGroupSessions: null,
    noOfGroups: 0,
    groups: [],
};

export const validationSchema = Yup.object({
    wereThereGroupSessions: Yup.boolean().required('error_required_field'),
    noOfGroups: Yup.number().min(0).when('wereThereGroupSessions', minOneWhenTrue()),
    groups: Yup.array().of(groupSchema).when('wereThereGroupSessions', minOneWhenTrue()),
});
